var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "small-12 large-9 column" }, [_c("Overlay")], 1),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }